import { Attributes, Misc, Model, ModelBase, NeoModel } from '@singularsystems/neo-core';
import { ExportEventTypeEnum } from '../Enums/ExportEventTypeEnum';

@NeoModel
export default class ServiceProviderFileGroupingExportSettingLookup extends ModelBase {
    public staticServiceProviderFileGroupingExportSettingId: number | null = null;

    public serviceProviderGroupingName: string = '';

    public staticServiceProviderFileGroupingId: number | null = null;

    public staticExportEventTypeId: number | null = null;

    public exportEventType: ExportEventTypeEnum | null = ExportEventTypeEnum.Export;

    public dayOfWeek: string = '';

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public eventTime: Date | null = null;

    public eventType: ExportEventTypeEnum | null = ExportEventTypeEnum.Export;

    public daysOfWeek: string[] = [];

    public daysOfWeekNumbers: number[] = [];

    @Attributes.NoTracking()
    public selectedDaysOfWeek: Model.ISelectedItem[] = [];
}
